export default {
  title: "Device statistics",
  description: "Kiosk product analytics from PostHog (production).",
  iframeTitle: "PostHog device statistics dashboard",
  rangeLabel: "Period",
  ranges: {
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    last90Days: "Last 90 days",
    thisMonth: "This month",
    lastMonth: "Last month",
  },
} as const;
